// removed by extract-text-webpack-plugin
module.exports = {"container":"_3eGo7MUsE2oM9iycVbqh0-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/styles.css
// module id = 1054
// module chunks = 0